// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".w-mobile[data-v-dc2b066e]{width:25%;}@media (min-width: 768px){.w-mobile[data-v-dc2b066e]{width:auto;}.w-mobile[data-v-dc2b066e]{min-width:0px;}}.w-mobile[data-v-dc2b066e]{min-width:25%;}@media (min-width: 640px){.w-mobile[data-v-dc2b066e]{width:15%;min-width:15%;}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
